import PropTypes from 'prop-types';
import React from 'react';

import ArmisLogoSvg from '../../../assets/images/armis-logo.svg';

const DEFAULT_HEIGHT = 40;

function ArmisLogo({ height = DEFAULT_HEIGHT }) {
    return <ArmisLogoSvg height={height} />;
}

ArmisLogo.propTypes = {
    height: PropTypes.number,
};

export default ArmisLogo;
